import { isValidDate } from 'utils/dates';

export default function (values, props) {
  const errors = {};
  if (
    !values.adfitNo ||
    values.adfitNo.length > 30 ||
    !/^[a-zA-Z0-9]+$/i.test(values.adfitNo)
  ) {
    errors.adfitNo = 'Invalid Debitsuccess ID, please try again';
  }
  if (!values.date) {
    errors.date = 'Please enter a date';
  }
  if (values.date && !isValidDate(values.date, 'DD/MM/YYYY')) {
    errors.date = 'Please enter a valid date - custom';
  }
  if (!values.colors) {
    errors.colors = 'Please select a color';
  }
  return errors;
}
